import React from 'react'
import { useTranslation } from 'react-i18next'

import Filter from '../../Filter/Filter'
import { renderSelectFloorPlaceholder, selectFloorOptions } from './helpers'
import type { FilterOption } from './useRecipientLocationFilters'

type Props = {
  values: {
    yardiPropertyId?: FilterOption | null
    buildingNumber?: FilterOption | null
    floor?: FilterOption[]
  }
  handleChange: (event: unknown) => void
  isYardiProperty: boolean
  yardiPropertyOptions: FilterOption[]
  buildingOptions: FilterOption[]
  floorOptions: FilterOption[]
}

export const RecipientLocationFilters = ({
  values,
  handleChange,
  isYardiProperty,
  yardiPropertyOptions,
  buildingOptions,
  floorOptions,
}: Props) => {
  const { t } = useTranslation(['organisation'])

  return (
    <>
      {isYardiProperty && (
        <Filter
          name="yardiPropertyId"
          placeholder={
            values.yardiPropertyId
              ? values.yardiPropertyId.text
              : t('organisation:communicationPortal.emailTemplate.selectPhasePlaceholder')
          }
          additionalClass="select-tags-or-buildings-dropdown"
          options={yardiPropertyOptions}
          value={values.yardiPropertyId ? [values.yardiPropertyId] : []}
          config={{ multiple: false, hasSearch: true }}
          disabled={!yardiPropertyOptions.length}
          onChange={handleChange}
        />
      )}
      <Filter
        name="buildingNumber"
        placeholder={
          values.buildingNumber
            ? values.buildingNumber.text
            : t('organisation:communicationPortal.emailTemplate.selectBuildingPlaceholder')
        }
        additionalClass="select-tags-or-buildings-dropdown"
        options={buildingOptions}
        value={values.buildingNumber ? [values.buildingNumber] : []}
        config={{ multiple: false, hasSearch: true }}
        disabled={!buildingOptions.length}
        onChange={handleChange}
      />
      <Filter
        name="floor"
        placeholder={renderSelectFloorPlaceholder(values.floor, t)}
        additionalClass="select-tags-or-buildings-dropdown"
        options={selectFloorOptions(floorOptions, t)}
        value={values.floor ?? []}
        config={{ multiple: true, hasSearch: true }}
        disabled={!buildingOptions.length || !floorOptions.length}
        onChange={handleChange}
      />
    </>
  )
}
